import { render } from "./InputScarcity.vue?vue&type=template&id=69c1644c"
import script from "./InputScarcity.vue?vue&type=script&lang=js"
export * from "./InputScarcity.vue?vue&type=script&lang=js"
script.render = render

export default script